export default __webpack_public_path__ + "static/pos-cd8a89dfc780d386fcaeb99b7bccdb84.mp4";